<div class="table-wrapper position-relative">

  <!-- Loading overlay -->
  <div *ngIf="loading" class="table-overlay">
    <div class="spinner-border text-success" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <div class="table-responsive">
    <table class="table table-hover table-sm align-middle mb-0" [class.table-compact]="compact">
      <thead>

        <!-- Column headers -->
        <tr>
          <th *ngFor="let col of columns"
              [class.table-sortable]="col.sortable"
              [class.table-sorted]="sortColumn === col.key"
              (click)="sort(col)">
            <div class="d-flex align-items-center gap-1 user-select-none">
              <span>{{ col.label }}</span>
              <span *ngIf="col.sortable" class="table-sort-icon">
                <!--fa-icon *ngIf="sortColumn !== col.key"                           [icon]="faArrowsUpDown"></fa-icon-->
                <fa-icon *ngIf="sortColumn === col.key && sortDirection === 'asc'"  [icon]="faArrowUp"></fa-icon>
                <fa-icon *ngIf="sortColumn === col.key && sortDirection === 'desc'" [icon]="faArrowDown"></fa-icon>
               </span>
            </div>
          </th>
        </tr>

        <!-- Filter inputs row -->
        <tr *ngIf="hasFilters" class="table-filter-row">
          <th *ngFor="let col of columns" class="py-1">
            <ng-container [ngSwitch]="col.filterType">

              <app-table-date-range-picker *ngSwitchCase="'daterange'"
                [(startDate)]="dateRangeValues[col.key].from"
                [(endDate)]="dateRangeValues[col.key].to"
                (startDateChange)="onDateRangeChange(col.key, 'from', $event)"
                (endDateChange)="onDateRangeChange(col.key, 'to', $event)">
              </app-table-date-range-picker>

              <select *ngSwitchCase="'select'"
                    class="form-select form-select-sm"
                    [(ngModel)]="filterValues[col.key]"
                    (ngModelChange)="onFilterChange()">
                <option value="">All</option>
                <option *ngFor="let opt of col.filterOptions" [value]="opt.value">{{ opt.label }}</option>
              </select>

              <input *ngSwitchDefault
                    [class.invisible]="!col.filterable"
                    type="search"
                    class="form-control form-control-sm"
                    placeholder=""
                    [(ngModel)]="filterValues[col.key]"
                    (ngModelChange)="onFilterChange()">

            </ng-container>
          </th>
        </tr>

      </thead>
      <tbody>

        <tr *ngIf="!loading && data.length === 0">
          <td [attr.colspan]="columns.length" class="text-center text-muted py-5">
            No results found.
          </td>
        </tr>

        <tr *ngFor="let row of data"
            [class.table-clickable]="clickableRows"
            (click)="clickableRows && rowClick.emit(row)">
          <td *ngFor="let col of columns">
            <ng-container *ngIf="getTemplate(col.key) as tmpl; else defaultCell">
              <ng-container *ngTemplateOutlet="tmpl; context: { $implicit: row }"></ng-container>
            </ng-container>
            <ng-template #defaultCell>{{ getCellValue(row, col.key) }}</ng-template>
          </td>
        </tr>

      </tbody>
    </table>
  </div>

  <!-- Footer: count + pagination -->
  <div class="d-flex align-items-center justify-content-between px-2 py-2 border-top">

    <span class="text-muted"  style="font-size: 0.75rem;">
      <ng-container *ngIf="totalCount > 0">
        Showing {{ showingFrom }}-{{ showingTo }} of {{ totalCount }}
      </ng-container>
      <ng-container *ngIf="totalCount === 0">No results</ng-container>
    </span>

    <div class="d-flex align-items-center gap-1" *ngIf="totalCount > 10">
      <label class="text-muted mb-0" style="font-size: 0.75rem;">Per page</label>
      <select class="form-select form-select-sm" style="width: auto;"
              [(ngModel)]="pageSize"
              (ngModelChange)="onPageSizeChange()">
        <option *ngFor="let opt of pageSizeOptions" [ngValue]="opt">{{ opt }}</option>
      </select>
    </div>

    <nav *ngIf="totalPages > 1">
      <ul class="pagination pagination-sm mb-0">

        <li class="page-item" [class.disabled]="currentPage === 1">
          <a class="page-link" role="button" (click)="goToPage(currentPage - 1)">
            <fa-icon [icon]="faChevronLeft"></fa-icon>
          </a>
        </li>

        <li *ngFor="let p of pages"
            class="page-item"
            [class.active]="p === currentPage"
            [class.disabled]="p === '...'">
          <a class="page-link" role="button" (click)="goToPage(p)">{{ p }}</a>
        </li>

        <li class="page-item" [class.disabled]="currentPage === totalPages">
          <a class="page-link" role="button" (click)="goToPage(currentPage + 1)">
            <fa-icon [icon]="faChevronRight"></fa-icon>
          </a>
        </li>

      </ul>
    </nav>

  </div>
</div>